var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "solutionguide__result-table" },
    [
      _c("div", { staticClass: "solutionguide__result-label" }, [
        _vm._v(_vm._s(_vm.$t("result.label.component"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "solutionguide__result-label" }, [
        _vm._v(_vm._s(_vm.$t("result.label.product"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "solutionguide__result-label" }, [
        _vm._v(_vm._s(_vm.$t("result.label.surface"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "solutionguide__result-label" }, [
        _vm._v(_vm._s(_vm.$t("result.label.decor"))),
      ]),
      _vm._v(" "),
      _vm._l(_vm.rows, function (row) {
        return [
          _c("div", { staticClass: "solutionguide__result-line" }),
          _vm._v(" "),
          _c("div", { staticClass: "solutionguide__result-mobilelabel" }, [
            _vm._v(_vm._s(_vm.$t("result.label.component"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "solutionguide__result-component" }, [
            _c("div", [_c("strong", [_vm._v(_vm._s(row.component.name))])]),
            _vm._v(" "),
            _c("img", {
              attrs: {
                src: row.component.icon,
                alt: "",
                title: row.component.name,
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "solutionguide__result-mobilelabel" }, [
            _vm._v(_vm._s(_vm.$t("result.label.product"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "solutionguide__result-productcol" }, [
            _c(
              "div",
              { staticClass: "solutionguide__result-product" },
              [
                row.product.detail_link
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href: row.product.detail_link,
                          target: "_blank",
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "solutionguide__result-product-img",
                          attrs: {
                            src: row.product.image_src,
                            alt: "",
                            title: row.product.title,
                          },
                        }),
                      ]
                    )
                  : _c("img", {
                      staticClass: "solutionguide__result-product-img",
                      attrs: {
                        src: row.product.image_src,
                        alt: "",
                        title: row.product.title,
                      },
                    }),
                _vm._v(" "),
                _c(
                  row.product.detail_link ? "a" : "p",
                  {
                    tag: "component",
                    attrs: { href: row.product.detail_link, target: "_blank" },
                  },
                  [
                    _c("span", [
                      _c("strong", [_vm._v(_vm._s(row.product.title))]),
                      _vm._v(" " + _vm._s(row.product.titlesuffix)),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    row.product.category
                      ? _c("span", [_vm._v(_vm._s(row.product.category))])
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "solutionguide__result-mobilelabel" }, [
            _vm._v(_vm._s(_vm.$t("result.label.surface"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "solutionguide__result-properties" }, [
            _c(
              "ul",
              _vm._l(
                _vm.getProperties(row.product.propertyIds),
                function (property) {
                  return _c("li", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(property.name) +
                        "\n                "
                    ),
                  ])
                }
              ),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "solutionguide__result-mobilelabel" }, [
            _vm._v(_vm._s(_vm.$t("result.label.decor"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "solutionguide__result-decor" },
            [
              _c("result-table-row-decor", {
                attrs: { component: row.component, product: row.product },
              }),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }